import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { accountLink, actualitiesLink, contactLink, directLink, jobLink } from './constants/endspoints';
import Direct from './views/Direct';
import Home from './views/Home';
import Grille from './views/Grille';
import Actuality from './views/Actuality';
import Account from './views/Account';
import ActualityDetail from './views/ActualityDetail';
import UserLayout from './layouts/UserLayout';
import NotFound from './views/NotFound';
import { getAuthToken } from './api/auth';
import Success from './views/Success';
import Error from './views/Error';
import { initializeWeglot } from './constants/functions';
import Contact from './views/Contact';
import Soon from './views/Soon';

const UserRoutesWithAnimation = () => {

    const [token, setToken] = useState(null);
    useEffect(() => {
        const authToken = getAuthToken();
        setToken(authToken);
    }, []);

    const location = useLocation()

    useEffect(() => {
        initializeWeglot()
    }, [location]);
    

    return (
        <Routes>
            {/* User Route */}
            <Route path='/'>
                <Route index element={<UserLayout><Home /></UserLayout>} />
                <Route path={directLink} element={<UserLayout><Direct /></UserLayout>} />
                <Route path={`${directLink}/grille_tv`} element={<UserLayout><Grille /></UserLayout>} />
                <Route path={actualitiesLink} element={<UserLayout><Actuality /></UserLayout>} />
                <Route path={`${actualitiesLink}/:id`} element={<UserLayout><ActualityDetail /></UserLayout>} />
                <Route path={contactLink} element={<UserLayout><Contact /></UserLayout>} />
                <Route path={jobLink} element={<UserLayout><Soon /></UserLayout>} />
                <Route path={accountLink} element={<UserLayout><Account /></UserLayout>} />
                <Route path={'success'} element={<UserLayout><Success /></UserLayout>} />
                <Route path={'error'} element={<UserLayout><Error /></UserLayout>} />
                {!token && <Route path='/404' element={<UserLayout><NotFound /></UserLayout>} />}
                {!token && <Route path='*' element={<UserLayout><NotFound /></UserLayout>} />}
            </Route>
        </Routes>
    );
};

export default UserRoutesWithAnimation;